import styles from '../orders-page.module.scss'
import { observer } from 'mobx-react-lite'
import {
  TableContainer,
  TableHeader,
  TableBodyContainer,
  TableBodyLine,
  TableBodyLineProps,
  PaginationButtons,
  H2,
} from '@touche-lts/panel-ui/dist'
// import { ProductSKUsDTO } from 'models/product-skus'
import { useRootStore } from 'mobx-stores/store-provider'
import { useEffect } from 'react'
import { OrdersDTO } from 'models'
import { OrdersTableSortProps, OrdersTableStatus } from 'mobx-stores/utils/orders-table-base/orders-table-base.types'
import moment from 'moment'
import { PictureNameLine } from 'components'
import { useGetScrollWidth } from 'hooks/custom-hooks'

const OrdersTableComponent = () => {
  const {
    ordersStore: {
      isColumnMarked,
      getSortDirection,
      handleSortDirectionChange,
      searchProps,
      onSearchPropsChange,
      searchResults,
      paginationInfo,
      onPageSelect,
      triggerSearch,
      statusShown,
      statusTableHeader
    }
  } = useRootStore()

  useEffect(() => {
    triggerSearch({ resetPageNumber: true })
  }, [triggerSearch])

  const {scrollX, handleScroll} = useGetScrollWidth()

  const orderTableCellWidth = {
    NUMBER : 350,
    DATE: 350,
    ORDER_STATUS : 350,
    TOTAL : 350,
    STORE : 350
  }

  const getBodyLineCells = (
    order: OrdersDTO
  ): TableBodyLineProps['cells'] => {
    const cells: any = [
      {
        // widthPercentage: 100
        widthPx: orderTableCellWidth.NUMBER,
        children: (
          <>
            {order.number}
          </>
        ),
        isColumnMarked: isColumnMarked(OrdersTableSortProps.NUMBER)
      },
      {
        // widthPercentage: 100,
        widthPx: orderTableCellWidth.DATE,
        children: (
          <>
            {order.date ? moment(order.date).format("DD MM YYYY") : ""}
          </>
        ),
        isColumnMarked: isColumnMarked(OrdersTableSortProps.DATE)
      },
      {
        // widthPercentage: 100,
        widthPx: orderTableCellWidth.ORDER_STATUS,
        children: (
          <>
            <span className={styles[order.orderStatus]}></span> {statusShown(order.orderStatus)}
          </>
        ),
        isColumnMarked: isColumnMarked(OrdersTableSortProps.ORDERSTATUS)
      },
      {
        // widthPercentage: 100,
        widthPx: orderTableCellWidth.TOTAL,
        children: (
          <span>{`$ ${order.price} ${order.itemsCount} items`}</span>

        ),
        isColumnMarked: isColumnMarked(OrdersTableSortProps.TOTAL)
      },
      {
        // widthPercentage: 100,
        widthPx: orderTableCellWidth.STORE,
        children: (
          <PictureNameLine
            imageSrc={order.store.images[0]?.url}
            imageBoxShadow
            name={order?.store?.name}
          />
        ),
        isColumnMarked: isColumnMarked(OrdersTableSortProps.STORE)
      },
    ]

    return cells
  },

    tableColumns: any = [
      {
        label: 'ORDER NUMBER',
        // widthPx: productsTableWidths.sku,
        isColumnMarked: isColumnMarked(OrdersTableSortProps.NUMBER),
        sortDirection: getSortDirection(OrdersTableSortProps.NUMBER),
        setSortDirection: handleSortDirectionChange(OrdersTableSortProps.NUMBER),
        inputProps: {
          placeholder: 'Search...',
          value: searchProps.number,
          onChange: (number => onSearchPropsChange({ number }))
        },
        widthPx: orderTableCellWidth.NUMBER,
      },
      {
        label: 'ORDER DATE',
        isColumnMarked: isColumnMarked(OrdersTableSortProps.DATE),
        sortDirection: getSortDirection(OrdersTableSortProps.DATE),
        setSortDirection: handleSortDirectionChange(
          OrdersTableSortProps.DATE
        ),
        periodFilterProps: {
          period: searchProps.orderDate,
          setPeriod: orderDate => onSearchPropsChange({ orderDate }),
        },
        widthPx: orderTableCellWidth.DATE,
      },
      {
        label: 'STATUS',
        isColumnMarked: isColumnMarked(OrdersTableSortProps.ORDERSTATUS),
        sortDirection: getSortDirection(OrdersTableSortProps.ORDERSTATUS),
        setSortDirection: handleSortDirectionChange(
          OrdersTableSortProps.ORDERSTATUS
        ),
        selectProps: {
          noneLabel: 'All',
          options: statusTableHeader,
          value: searchProps.status,
          onChange: (status: OrdersTableStatus) => onSearchPropsChange({ status })
        },
        widthPx: orderTableCellWidth.ORDER_STATUS,
      },
      {
        label: 'PURCHASE TOTAL',
        isColumnMarked: isColumnMarked(OrdersTableSortProps.TOTAL),
        sortDirection: getSortDirection(OrdersTableSortProps.TOTAL),
        setSortDirection: handleSortDirectionChange(
          OrdersTableSortProps.TOTAL
        ),
        sliderFilterProps: {
          label: 'order product',
          min: 0,
          max: 1000,
          value: [searchProps.minAmount, searchProps.maxAmount],
          onChange: ([minAmount, maxAmount]) =>
            onSearchPropsChange({ minAmount, maxAmount })
        },
        widthPx: orderTableCellWidth.TOTAL,
      },
      {
        label: 'store',
        isColumnMarked: isColumnMarked(OrdersTableSortProps.STORE),
        sortDirection: getSortDirection(OrdersTableSortProps.STORE),
        setSortDirection: handleSortDirectionChange(
          OrdersTableSortProps.STORE
        ),
        inputProps: {
          placeholder: 'Search...',
          value: searchProps.store,
          onChange: (store => onSearchPropsChange({ store }))
        },
        widthPx: orderTableCellWidth.STORE,
      }
    ]

  return (


    <TableContainer  style={{
      maxHeight: "770px",
      height: "770px",
      marginTop: 20,
      overflowX : 'auto'
    }} className={styles.thinScroll} onScroll={handleScroll}>
      <div style={{ padding: 25 }}>
        <H2 style={{ paddingBottom: 10 }}>Orders</H2>
        <TableHeader tableColumns={tableColumns} />
        <TableBodyContainer className={styles.tableBodyContainer}>
          {searchResults.map((order: OrdersDTO) => {
            return (
              <TableBodyLine cells={getBodyLineCells(order)} />
            )
          })}
        </TableBodyContainer>
        <PaginationButtons
          alwaysShow
          {...paginationInfo}
          onPageSelect={onPageSelect}
          style={{width : scrollX === '100%' ? "100%" : "168%" }}
        />
      </div >
    </TableContainer >
  )
},

  OrdersTable = observer(OrdersTableComponent)
export { OrdersTable }
